import { render, staticRenderFns } from "./AddLegislation.vue?vue&type=template&id=6c970de6&scoped=true"
import script from "./AddLegislation.vue?vue&type=script&lang=js"
export * from "./AddLegislation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c970de6",
  null
  
)

export default component.exports